/* eslint-disable react/no-danger */
import React from 'react';
// import { DadosAtaTypes } from 'store/modules/ata_registration_price_store/types';
import ContractsIcon from 'assets/images/contracts/icon_download_contract.svg';
import moment from 'moment';
import { Container, TableHead } from './styles';

interface AtaRegistrationInfoProps {
  dados: any;
}

const AtaRegistrationInfo = (props: AtaRegistrationInfoProps) => {
  const { dados } = props;

  return (
    <Container className="my-2">
      <TableHead className="row py-3 m-0 d-md-flex d-none">
        <div className="col-md-4">Nome</div>
        <div className="col-md-3">Data</div>
        <div className="col-md-3">Tipo</div>
        <div className="col-md-2" />
      </TableHead>

      {dados?.map((ata: any) => (
        <div className="row mt-3 mx-0 border-bottom pb-3">
          <div
            className="table-card-responsive col-12 col-md-4 font-color-more"
            data-title="Nome"
            dangerouslySetInnerHTML={{
              __html: ata?.document_title || '-',
            }}
          />
          <div className="table-card-responsive col-12 col-md-3" data-title="Data">
            {moment(ata?.document_date).format('DD/MM/YYYY HH:mm')}
          </div>
          <div
            className="table-card-responsive col-12 col-md-3 font-color-more"
            data-title="Tipo"
            dangerouslySetInnerHTML={{
              __html: ata?.document_title || '-',
            }}
          />
          <div className="no-data-title col-12 col-md-2 text-center">
            <a href={ata?.url_ata} download="arquivo">
              <img
                alt="Tudo sobre Licitações Públicas e Pregão - Conlicitação"
                src={ContractsIcon}
              />
            </a>{' '}
          </div>
        </div>
      ))}
    </Container>
  );
};

export default AtaRegistrationInfo;
